import type { ColumnDimensionType } from '@modules/page-builder/types';

export const FULL_COLUMN_WIDTH = 1820;
export const FULL_COLUMN_WIDTH_MOBILE = 414;
export const COLUMN_WIDTH_100 = 1820;
export const DUO_COLUMN_WIDTH = 1440;
// the min width for the medium image of the DuoImageModule
export const DUO_COLUMN_WIDTH_MD = 614;
export const GALLERY_COLUMN_WIDTH = 434;
export const GALLERY_COLUMN_WIDTH_MOBILE = 186;
export const GALLERY_ITEMS_PER_ROW = 4;
export const PARAGRAPH_PHOTO_WIDTH = 576;
export const ROW_GAP_MOBILE = 30;
const BANNER_WIDTH_TABLET = 742;
export const BANNER_WIDTH_FULL_MOBILE = 414;
const BANNER_HEIGHT_DESKTOP = 818;
const BANNER_HEIGHT_TABLET = 494;
const BANNER_HEIGHT_FULL_MOBILE = 378;

export const FULL_COLUMN_WIDTH_FULL_SCREEN = 1920;
export const BANNER_HEIGHT_DESKTOP_FULL_SCREEN = 1024;

export const BANNER_DIMENSIONS: ColumnDimensionType = {
    id: 0,
    width: FULL_COLUMN_WIDTH,
    height: BANNER_HEIGHT_DESKTOP,
    tabletWidth: BANNER_WIDTH_TABLET,
    tabletHeight: BANNER_HEIGHT_TABLET,
    mobileWidth: BANNER_WIDTH_FULL_MOBILE,
    mobileHeight: BANNER_HEIGHT_FULL_MOBILE,
    isPortrait: false,
};
